import api from './client';
let entity = 'pdata';


export const create = async (entry) => {
  const { data } = await api.post(`/${entity}`, entry);
  return data;
};

export const getAll = async () => {
  const { data } = await api.get(`/${entity}`);
  return data;
};

export const getByDate = async (date) => {
  const { data } = await api.get(`/${entity}/date/${date}`);
  return data;
};

export const getByDateRange = async (startDate, endDate) => {
  const { data } = await api.get(`/${entity}/date/range/${startDate}/${endDate}`);
  return data;
};

export const deletePdata = async (id) => {
  const { data } = await api.delete(`/${entity}/${id}`);
  return data;
}


